/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosDelegationNodeListRequest = {
    sortField?: AptosDelegationNodeListRequest.sortField;
    sortDirection?: AptosDelegationNodeListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace AptosDelegationNodeListRequest {

    export enum sortField {
        DELEGATION_AMOUNT = 'DELEGATION_AMOUNT',
        COMMISSION = 'COMMISSION',
        DELEGATORS = 'DELEGATORS',
        REWARD_EARNED = 'REWARD_EARNED',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

